import { cn } from "@/lib/utils";
import { Thumbnail, ThumbnailFallback, ThumbnailImage } from "@backpac/monica";

interface WorkspaceIconProps {
  workspaceName?: string;
  thumbnailUrl?: string;
  className?: string;
}

export function WorkspaceIcon({ workspaceName, thumbnailUrl, className }: WorkspaceIconProps) {
  return (
    <Thumbnail variant="square" className={cn("size-6", className)}>
      <ThumbnailImage src={thumbnailUrl} alt="" />
      <ThumbnailFallback className="bg-textSubtle text-white">
        {workspaceName?.charAt(0).toLocaleUpperCase() ?? "W"}
      </ThumbnailFallback>
    </Thumbnail>
  );
}
